import { EMPTY_DEFAULT, useScreenBreakpoint } from '@anyx/shared-utils';

interface TagHolderProps {
  tags: string[];
  className?: string;
}

export const ChatTag = ({ className, text }: { className?: string; text: string }) => {
  return (
    <span className={`bg-gray-1 text-3xs rounded-sm text-center leading-3.75 ${className}`}>
      {text}
    </span>
  );
};

export const TagHolder = ({ tags, className }: TagHolderProps) => {
  const isLargeScreen = useScreenBreakpoint('lg');

  if (tags?.length === 0) return <p className="mx-2">{EMPTY_DEFAULT}</p>;

  const displayedTags = isLargeScreen ? 4 : 2;

  const sliced = [...tags].slice(0, displayedTags);
  const missing = tags.length - displayedTags;

  return (
    <div
      className={`text-3xs flex flex-wrap items-start justify-end gap-1 sm:justify-start lg:py-1 ${className}`}
    >
      {sliced.map((tag) => (
        <ChatTag key={tag} className="max-w-27 truncate px-2 py-0.5 sm:max-w-none" text={tag} />
      ))}
      {missing > 0 && <ChatTag className="px-2 py-0.5" text={`+${missing}`} />}
    </div>
  );
};
